/** Now really just wrapping Raphael.image */

module.exports = function( paper, src, x, y, width, height ) {

    return paper.image( src, x, y, width, height );

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphicStamp/createImgEl.js
 ** module id = 385
 ** module chunks = 0
 **/